<template>
  <div
    class="relative flex w-full flex-wrap gap-3 lg:flex-nowrap min-[1301px]:flex-row flex-col items-center min-[1301px]:items-start"
  >
    <div
      id="room-players"
      class="w-full shadow-xl rounded-2xl overflow-hidden border border-1"
    >
      <RoomPlayers />
    </div>

    <div
      id="live-info"
      class="w-full shadow-xl rounded-2xl overflow-visible border border-1"
    >
      <LiveRoundInformation />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RoomPlayers from "./charts/RoomPlayers.vue";
import LiveRoundInformation from "./LiveRoundInformation.vue";

export default {
  name: "RoundLiveInfo",
  components: {
    RoomPlayers,
    LiveRoundInformation,
  },
  computed: {
    ...mapGetters(["isMenuOpen"]),
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
